import {
  HouseCorporateEveningGlobal,
  HouseCorporateEveningGlobalDto,
} from '../../../../../../../lib/graphql'

// JLN - SOIREES V2
/* const computeInputPrice = (value: undefined | null | string | number) => {
  return value === '' || value === null || value === undefined ? null : multiplyByFactor(value)
} */

export const computeHouseCorporateEveningGlobalInputs = ({
  isEnabled,
  options,
}: HouseCorporateEveningGlobalDto): HouseCorporateEveningGlobalDto => {
  const computedInputs: HouseCorporateEveningGlobalDto = {
    isEnabled,
    options: {
      capacity: {
        max: Number(options.capacity.max),
        min: Number(options.capacity.min),
      },
      // JLN - SOIREES V2
      seasonalPrices: [
        /* {
          endAt: options.seasonalPrices[0].endAt,
          startAt: options.seasonalPrices[0].startAt,
          overStayMax: {
            highPrice: computeInputPrice(options.seasonalPrices[0].overStayMax.highPrice),
            lowPrice: computeInputPrice(options.seasonalPrices[0].overStayMax.lowPrice),
            mediumPrice: computeInputPrice(options.seasonalPrices[0].overStayMax.mediumPrice),
          },
          regular: {
            highPrice: computeInputPrice(options.seasonalPrices[0].regular.highPrice),
            lowPrice: computeInputPrice(options.seasonalPrices[0].regular.lowPrice),
            mediumPrice: computeInputPrice(options.seasonalPrices[0].regular.mediumPrice),
          },
        }, */
      ],
      hours: {
        endAt: options.hours.endAt,
        overStayMaxAt: options.hours.overStayMaxAt,
        startAt: options.hours.startAt,
      },
      vatRate: options.vatRate,
    },
  }

  return computedInputs
}

// JLN - SOIREES V2
/* const computeDefaultValuePrice = (value: undefined | null | number) => {
  return value === null || value === undefined ? null : divideByFactor(value)
} */

export const computeHouseCorporateEveningGlobalDefaultValues = ({
  isEnabled,
  options,
}: HouseCorporateEveningGlobal): HouseCorporateEveningGlobalDto => {
  const computedInputs: HouseCorporateEveningGlobalDto = {
    isEnabled,
    options: options
      ? {
          capacity: {
            max: options.capacity.max,
            min: options.capacity.min,
          },
          hours: {
            endAt: options.hours.endAt,
            overStayMaxAt: options.hours.overStayMaxAt,
            startAt: options.hours.startAt,
          },
          // JLN - SOIREES V2
          seasonalPrices: [
            {
              endAt: null /*  options.seasonalPrices[0].endAt */,
              startAt: null /*  options.seasonalPrices[0].startAt */,
              overStayMax: {
                highPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].overStayMax.highPrice), */,
                lowPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].overStayMax.lowPrice), */,
                mediumPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].overStayMax.mediumPrice), */,
              },
              regular: {
                highPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].regular.highPrice), */,
                lowPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].regular.lowPrice), */,
                mediumPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].regular.mediumPrice), */,
              },
            },
          ],
          vatRate: options.vatRate,
        }
      : {
          capacity: { max: 0, min: 0 },
          hours: {
            endAt: '00:00',
            overStayMaxAt: '23:00',
            startAt: '18:00',
          },
          // JLN - SOIREES V2
          seasonalPrices: [
            {
              endAt: null,
              startAt: null,
              overStayMax: {
                highPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].overStayMax.highPrice), */,
                lowPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].overStayMax.lowPrice), */,
                mediumPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].overStayMax.mediumPrice), */,
              },
              regular: {
                highPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].regular.highPrice), */,
                lowPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].regular.lowPrice), */,
                mediumPrice:
                  null /* computeDefaultValuePrice(options.seasonalPrices[0].regular.mediumPrice), */,
              },
            },
          ],
          vatRate: null,
        },
  }

  return computedInputs
}
